// Hideo - translations for components: the same functions as src/i18n (the language never changes while the app runs:
// changing it reloads the page, so nothing needs to be reactive).
import { LANG, LOCALE, t, tn, tv } from '../i18n'

export function useI18n() {
  return { t, tn, tv, lang: LANG, locale: LOCALE }
}
